<template>
    <div>
    <h2 class="title">
        <span>{{title}}</span>
    </h2>
    </div>
</template>

<script>
    export default {
        name: 'Title',
        props: {
            title: String
        }
    }
</script>

<style>
    h2 span{
        padding: 8px 0px 8px 0px;
        border-width: 2px 0px 2px 0px;
        border-style: solid;
    }
    .title{
        margin-bottom: 25px;
    }
</style>